<template>
    <template v-for="(rB, index) in relationshipBlocks"
              :key="`relationship-block-${index}`">
        <relationship-block v-model="relationshipBlocks[index]"
                            :patient-id="patientId"
                            :edit-state="editState"
                            :flat="flat"
                            :url-head="urlHead" />
        <hr v-if="index < relationshipBlocks.length - 1">
    </template>
</template>

<script setup>
    import { defineProps, defineEmits, computed } from 'vue';
    import relationshipBlock from './RelationshipBlock.vue';

    const props = defineProps({
        modelValue: {
            type: Array,
            default: null
        },
        patientId: {
            type: Number,
            default: 0
        },
        editState: {
            type: Number,
            default: 0
        },
        flat: {
            type: Boolean,
            default: false
        },
        urlHead: {
            type: String,
            default: null
        }
    });

    const emit = defineEmits(['update:modelValue']);

    const relationshipBlocks = computed({
        get: () => props.modelValue,
        set: newValue => emit("update:modelValue", newValue)
    });

</script>